import { Box } from "@mui/system";
import { useRef } from "react";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useEntityInputFormInfo } from "@/common/hooks/entity/useEntityInputFormInfo";

import AppModalContent from "../../Modals/AppModalContent";
import {
  BaseEntityCreateUpdateModal,
  BaseEntityCreateUpdateModalInheritableProps,
} from "../components/BaseEntityCreateUpdateModal";
import DamageCostEvaluationCreateUpdate, {
  DamageCostEvaluationCreateUpdateHandle,
  DamageCostEvaluationCreateUpdateProps,
} from "./DamageCostEvaluationCreateUpdate";

export type DamageCostEvaluationCreateUpdateModalProps = {
  createUpdateProps: DamageCostEvaluationCreateUpdateProps;
} & BaseEntityCreateUpdateModalInheritableProps;

export default function DamageCostEvaluationCreateUpdateModal({
  createUpdateProps,
  ...modalProps
}: DamageCostEvaluationCreateUpdateModalProps) {
  const formInfo = useEntityInputFormInfo({ entityId: createUpdateProps.damageCostEvaluationId });
  const formWrapperRef = useRef<DamageCostEvaluationCreateUpdateHandle | null>(null);

  return (
    <BaseEntityCreateUpdateModal
      fullWidth
      maxWidth='xl'
      {...modalProps}
      formWrapperRef={formWrapperRef}
    >
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>
            {formInfo.isCreate ? "Create new" : "Edit"} damage cost evaluation
          </AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <DamageCostEvaluationCreateUpdate ref={formWrapperRef} {...createUpdateProps} />
            </Box>
          </AppModalContent>
        </>
      )}
    </BaseEntityCreateUpdateModal>
  );
}
